import React, { useState, useEffect, useContext } from "react";
import { Message_data } from "../context/context";
import cn from "classnames";
import { Avatar } from "./Avatar";
import "../styles/Chat.scss";

import {
  PrevButton,
  NextButton,
  usePrevNextButtons,
} from "./EmblaCarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";

const VerticalCarousel2 = ({
  avatars,
  data,
  openChat,
  loadingAni,
  resetTimer,
  auth,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { message, setMessage } = useContext(Message_data);
  const OPTIONS = { axis: "y", align: "start", dragFree: true, loop: true };

  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  useEffect(() => {
    const idx = data.findIndex((chat) => chat.unreadAmount > 0);
    if (idx !== -1) {
      // send message to highlight chat tab
      console.log("***************data updated****************");
      const highlightChatTab = {
        highlightChatTab: true,
      };
      setMessage(JSON.stringify(highlightChatTab));
    } else {
      const highlightChatTab = {
        highlightChatTab: false,
      };
      setMessage(JSON.stringify(highlightChatTab));
    }
  }, [data, setMessage]);

  // Used to determine which items appear above the active item
  const halfwayIndex = Math.ceil(data.length / 2);

  // Usd to determine the height/spacing of each item
  const itemHeight = 52;

  // Used to determine at what point an item is moved from the top to the bottom
  const shuffleThreshold = halfwayIndex * itemHeight;

  // Used to determine which items should be visible. this prevents the "ghosting" animation
  const visibleStyleThreshold = shuffleThreshold / 2;

  const determinePlacement = (itemIndex) => {
    // If these match, the item is active
    if (activeIndex === itemIndex) return 0;

    if (itemIndex >= halfwayIndex) {
      if (activeIndex > itemIndex - halfwayIndex) {
        return (itemIndex - activeIndex) * itemHeight;
      } else {
        return -(data.length + activeIndex - itemIndex) * itemHeight;
      }
    }

    if (itemIndex > activeIndex) {
      return (itemIndex - activeIndex) * itemHeight;
    }

    if (itemIndex < activeIndex) {
      if ((activeIndex - itemIndex) * itemHeight >= shuffleThreshold) {
        return (data.length - (activeIndex - itemIndex)) * itemHeight;
      }
      return -(activeIndex - itemIndex) * itemHeight;
    }
  };

  const handleClick = (direction) => {
    setActiveIndex((prevIndex) => {
      if (direction === "next") {
        if (prevIndex + 1 > data.length - 1) {
          return 0;
        }
        return prevIndex + 1;
      }

      if (prevIndex - 1 < 0) {
        return data.length - 1;
      }

      return prevIndex - 1;
    });
  };

  const getAvatar = (users) => {
    // console.log("getAvatar users", users);

    // const uid = () => {
    const lastUser = users.filter((user) => user.id !== auth.currentUser.uid);
    // console.log("lastUser", lastUser);
    
    // Check if lastUser array has any users
    if (!lastUser || lastUser.length === 0) {
      return null; // Return null if no users found
    }
    
    // console.log('lastUser[lastUser.length - 1].id', lastUser[lastUser.length - 1].id)
    return lastUser[lastUser.length - 1].id;
    // };
    // console.log("getAvatar uid", uid());
  };

  return (
    <div className="chatlist-carousel-container">
      <section className="outer-container">
        <div className="carousel-wrapper">
          <section className="mbembla">
            <div className="mbembla__controls">
              <div className="mbembla__buttons">
                <PrevButton
                  onClick={onPrevButtonClick}
                  disabled={prevBtnDisabled}
                />
              </div>
            </div>

            <div className="mbembla__viewport" ref={emblaRef}>
              <div className="mbembla__container">
                {data.map((chat, i) => (
                  <div
                    className={cn("mbembla__slide mb-embla-carousel-item", {
                      unread: chat.unreadAmount > 0,
                      newchat: chat.newchat > 0,
                      active: activeIndex === i,
                      visible:
                        Math.abs(determinePlacement(i)) <=
                        visibleStyleThreshold,
                    })}
                    onClick={(e) => {
                      setActiveIndex(i);
                      loadingAni();
                      openChat(e, chat.chatId, chat.type, chat.users);
                      resetTimer();
                    }}
                    key={i}
                  >
                    {/* <div className="mbembla__slide__number text-white">{i + 1}</div> */}

                    <div className="flex items-center justify-center h-14 w-14   rounded-full border overflow-hidden ebzbg-indigo-500 flex-shrink-0">
                      {chat && (
                        <>
                          {chat.type === "private" ? (
                            <>
                            <Avatar
                              avObj={avatars}
                              // uid={chat.users[1].id}
                              uid={getAvatar(chat.users)}
                              // uid={() => {
                              //   const lastUser = chat.users.filter(
                              //     (user) => user.id !== auth.currentUser.uid
                              //   );
                              //   console.log('lastUser', lastUser)
                              //   // console.log('lastUser[lastUser.length - 1].id', lastUser[lastUser.length - 1].id)
                              //   return lastUser[lastUser.length - 1].id;
                              // }}
                            />
                            </>
                          ) : (
                            <div>
                              <img
                                src={chat.coverart}
                                alt={chat.track}
                                title={chat.track}
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    <div className="flex items-center justify-center ml-auto text-xs text-white bg-red-500 h-5 w-5 rounded leading-none absolute top-4 right-0">
                      {chat && <>{chat.unreadAmount}</>}
                    </div>
                  </div>

                  // <button
                  //   type="button"
                  //   onClick={(e) => {
                  //     setActiveIndex(i);
                  //     loadingAni();
                  //     openChat(e, chat.chatId, chat.type, chat.users);
                  //     resetTimer();
                  //   }}
                  //   className={cn("carousel-item", {
                  //     unread: chat.unreadAmount > 0,
                  //     newchat: chat.newchat > 0,
                  //     active: activeIndex === i,
                  //     visible:
                  //       Math.abs(determinePlacement(i)) <=
                  //       visibleStyleThreshold,
                  //   })}
                  //   key={chat.id}
                  //   style={{
                  //     transform: `translateY(${determinePlacement(i)}px)`,
                  //   }}
                  // >
                  //   <div className="flex items-center justify-center h-12 w-12   rounded-full border overflow-hidden ebzbg-indigo-500 flex-shrink-0">
                  //     {chat && (
                  //       <>
                  //         {chat.type === "private" ? (
                  //           <Avatar
                  //             avObj={avatars}
                  //             // uid={chat.users[1].id}
                  //             uid={getAvatar(chat.users)}
                  //             // uid={() => {
                  //             //   const lastUser = chat.users.filter(
                  //             //     (user) => user.id !== auth.currentUser.uid
                  //             //   );
                  //             //   console.log('lastUser', lastUser)
                  //             //   // console.log('lastUser[lastUser.length - 1].id', lastUser[lastUser.length - 1].id)
                  //             //   return lastUser[lastUser.length - 1].id;
                  //             // }}
                  //           />
                  //         ) : (
                  //           <div>
                  //             <img
                  //               src={chat.coverart}
                  //               alt={chat.track}
                  //               title={chat.track}
                  //             />
                  //           </div>
                  //         )}
                  //       </>
                  //     )}
                  //   </div>

                  //   <div className="flex items-center justify-center ml-auto text-xs text-white bg-red-500 h-5 w-5 rounded leading-none absolute top-0 -right-2">
                  //     {chat && <>{chat.unreadAmount}</>}
                  //   </div>
                  // </button>
                ))}
              </div>
            </div>

            <div className="mbembla__controls">
              <div className="mbembla__buttons">
                <NextButton
                  onClick={onNextButtonClick}
                  disabled={nextBtnDisabled}
                />
              </div>
            </div>
          </section>

          <button
            type="button"
            className="carousel-button prev hide"
            onClick={() => {
              handleClick("prev");
              resetTimer();
            }}
          >
            &#10148;
          </button>

          <div className="carousel hide">
            <div className="slides">
              <div className="carousel-inner relative z-10">
                {data.length > 4 ? (
                  <>
                    {data.map((chat, i) => {
                      // if (chat.unreadAmount > 0) {
                      //   // now highlight the chat tab in the 2nd layout using context message to the AppLayout2

                      //   const d = new Date();
                      //   let seconds = d.getSeconds();
                      //   const rand = Math.floor(Math.random() * seconds);
                      //   console.log("rand", rand);
                      //   const highlightChatTab = {
                      //     highlightChatTab: JSON.stringify(rand),
                      //   };
                      //   setMessage(JSON.stringify(highlightChatTab));
                      // }

                      return (
                        <button
                          type="button"
                          onClick={(e) => {
                            setActiveIndex(i);
                            loadingAni();
                            openChat(e, chat.chatId, chat.type, chat.users);
                            resetTimer();
                          }}
                          className={cn("carousel-item", {
                            unread: chat.unreadAmount > 0,
                            newchat: chat.newchat > 0,
                            active: activeIndex === i,
                            visible:
                              Math.abs(determinePlacement(i)) <=
                              visibleStyleThreshold,
                          })}
                          key={chat.id}
                          style={{
                            transform: `translateY(${determinePlacement(i)}px)`,
                          }}
                        >
                          <div className="flex items-center justify-center h-12 w-12   rounded-full border overflow-hidden ebzbg-indigo-500 flex-shrink-0">
                            {chat && (
                              <>
                                {chat.type === "private" ? (
                                  <Avatar
                                    avObj={avatars}
                                    // uid={chat.users[1].id}
                                    uid={getAvatar(chat.users)}
                                    // uid={() => {
                                    //   const lastUser = chat.users.filter(
                                    //     (user) => user.id !== auth.currentUser.uid
                                    //   );
                                    //   console.log('lastUser', lastUser)
                                    //   // console.log('lastUser[lastUser.length - 1].id', lastUser[lastUser.length - 1].id)
                                    //   return lastUser[lastUser.length - 1].id;
                                    // }}
                                  />
                                ) : (
                                  <div>
                                    <img
                                      src={chat.coverart}
                                      alt={chat.track}
                                      title={chat.track}
                                    />
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          <div className="flex items-center justify-center ml-auto text-xs text-white bg-red-500 h-5 w-5 rounded leading-none absolute top-0 -right-2">
                            {chat && <>{chat.unreadAmount}</>}
                          </div>
                        </button>
                      );
                    })}
                  </>
                ) : (
                  <ul>
                    {data.map((chat, i) => (
                      <li key={i}>
                        <button
                          type="button"
                          onClick={(e) => {
                            setActiveIndex(i);
                            loadingAni();
                            openChat(e, chat.chatId, chat.type, chat.users);
                            resetTimer();
                          }}
                          key={chat.id}
                          style={{
                            position: `relative`,
                          }}
                          className={cn("chatlist-item", {
                            unread: chat.unreadAmount > 0,
                            newchat: chat.newchat > 0,
                          })}
                        >
                          <div className="flex items-center justify-center h-12 w-12   rounded-full border overflow-hidden ebzbg-indigo-500 flex-shrink-0">
                            {chat && (
                              <>
                                {chat.type === "private" ? (
                                  <Avatar
                                    avObj={avatars}
                                    uid={chat.users[1].id}
                                  />
                                ) : (
                                  <div>
                                    <img
                                      src={chat.coverart}
                                      alt={chat.track}
                                      title={chat.track}
                                    />
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          <div className="flex items-center justify-center ml-auto text-xs text-white bg-red-500 h-5 w-5 rounded leading-none absolute top-0 right-0 red-badge">
                            {chat && <>{chat.unreadAmount}</>}
                          </div>
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>

          <button
            type="button"
            className="carousel-button next hide"
            onClick={() => {
              handleClick("next");
              resetTimer();
            }}
          >
            &#10148;
          </button>
        </div>
      </section>
    </div>
  );
};

export default VerticalCarousel2;
